/* tslint:disable */
/* eslint-disable */
/**
 * Ameta Security API
 * A rest api for managing the ameta security system
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    SecurityYearObject,
    SecurityYearObjectFromJSON,
    SecurityYearObjectFromJSONTyped,
    SecurityYearObjectToJSON,
} from './';

/**
 * 
 * @export
 * @interface SecurityCounterData
 */
export interface SecurityCounterData {
    /**
     * 
     * @type {{ [key: string]: SecurityYearObject; }}
     * @memberof SecurityCounterData
     */
    years: { [key: string]: SecurityYearObject; };
}

export function SecurityCounterDataFromJSON(json: any): SecurityCounterData {
    return SecurityCounterDataFromJSONTyped(json, false);
}

export function SecurityCounterDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): SecurityCounterData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'years': (mapValues(json['years'], SecurityYearObjectFromJSON)),
    };
}

export function SecurityCounterDataToJSON(value?: SecurityCounterData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'years': (mapValues(value.years, SecurityYearObjectToJSON)),
    };
}


